export default "__VITE_ASSET__94f09986__"